import { defineStore } from 'pinia';
import { type UserState } from './types';
import { ref } from 'vue';
import { getToken } from '@/utils/auth';
import { $fetch } from '@/utils/base-fetch';

const useUserStore = defineStore('user', () => {
  const getInitUser = (): UserState => ({
    id: undefined,
    photo: undefined,
    username: undefined,
    nickname: undefined,
    email: undefined,
    phone: undefined,
  });

  const user = ref<UserState>(getInitUser());

  const setInfo = (partial: Partial<UserState>) => {
    user.value = { ...user.value, ...partial };
  }

  const resetInfo = () => {
    user.value = getInitUser();
  }

  // Get user's information
  const fetchInfo = async (cookie?: string) => {
    if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
      setInfo({
        id: '1',
        photo: 'https://lf1-xgcdn-tos.pstatp.com/obj/vcloud/vadmin/start.8e0e4855ee346a46ccff8ff3e24db27b.png',
        email: 'wangliqun@email.com',
        username: 'wangliqun',
        nickname: 'wlq',
      });

      return {
        isSuccess: true,
        code: 200,
      };
    }
    else {
      const { isSuccess, data, msg, code } = await $fetch<{
        user_id: number;
        login: string;
        name: string;
        company: string;
        avatar_url: string;
        role: string;
      }>('/api/auth/userinfo', {
        method: 'post',
        headers: {
          Authorization: `Bearer ${getToken(cookie)}`,
        },
      });

      if (isSuccess && data) {
        setInfo({
          id: data.user_id !== undefined ? String(data.user_id) : undefined,
          photo: data.avatar_url,
          username: data.login,
          nickname: data.name,
        });
      }

      return {
        isSuccess, msg,
        code: Number(code),
      };
    }
  }

  return {
    user,
    setInfo,
    resetInfo,
    fetchInfo,
  };
});

export default useUserStore;
